interface ExportPreference {
    separator?: string;
    wrapper?: string;
    textFormat?: string;
}

const savePreferences = (preference: ExportPreference = {}): Promise<unknown> => {
    return (SellsyJS as { WebServiceCaller: { post: (url: string, params: Record<string, unknown>, data: ExportPreference) => Promise<unknown> } }).WebServiceCaller.post(
        '/settings/exports/preference',
        {},
        preference,
    );
};

export { savePreferences };
export type { ExportPreference };
